import { Injectable } from '@angular/core';
import * as signalR from '@aspnet/signalr';
import { HubConnection } from '@aspnet/signalr';
// import * as signalR from '@microsoft/signalr';
// import { HubConnection } from '@microsoft/signalr';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject } from 'rxjs';
import { HubServices } from '../../net/apiRoute';
import { UserTokenService } from '../../services/user-token.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  //连接对象
  private _connection: HubConnection;
  public notice = new Subject<any>();
  private startPromise: Promise<void>;
  constructor(private message: NzMessageService, public tokenSerivce: UserTokenService) {
    this._connection = new signalR.HubConnectionBuilder()
      .withUrl(HubServices.chatUrl, {
        //         skipNegotiation: true,
        //         transport: signalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => this.tokenSerivce.get()
      })
      .configureLogging(signalR.LogLevel.Information)
      .build();
    this._connection.onclose((n) => {
      var loginOut = this.tokenSerivce.get();
      if (!loginOut) {
        return;
      }
      this.message.create('error', `网络连接已断开，2秒后重试连接!`);
      setTimeout(() => {
        this.start();
      }, 2000);
    });

  }



  public start() {
    var that = this;
    this.startPromise = this._connection.start().catch(function (err: signalR.HttpError) {
      if (err.statusCode == 401) {
        that._connection.stop();
        return;
      }
      setTimeout(() => {
        that.start();
      }, 3000)
    });
    return this.startPromise;
  }


  get connection(): Promise<HubConnection> {
    return new Promise<HubConnection>(resolve => {
      if (this._connection.state == signalR.HubConnectionState.Connected) {
        resolve(this._connection);
      }
      else if (this._connection.state == signalR.HubConnectionState.Disconnected) {

        this.start().then(() => resolve(this._connection));

      }
      else {
        this.startPromise.then(() => resolve(this._connection));
      }
    });
  }


}
